import {Component, ComponentRef, Input, OnDestroy, ViewChild, ViewContainerRef} from '@angular/core';
import {timer} from 'rxjs';
import scrollIntoView from 'scroll-into-view-if-needed';

import {LINK_POPUP_DELAY} from '../../defines/client.const';
import {WordDetailExample} from '../../models/word.model';
import {LinkExamplePopupComponent} from '../link-example-popup/link-example-popup.component';
import {DynamicComponentService} from '../../services/dynamic-component/dynamic-component.service';
import {GlobalEventService} from '../../services/global-event/global-event.service';

@Component({
  selector: 'app-link-example',
  templateUrl: './link-example.component.html',
  styleUrls: ['./link-example.component.scss'],
})
export class LinkExampleComponent implements OnDestroy {
  @ViewChild('container', {read: ViewContainerRef}) container!: ViewContainerRef;
  @Input() example: WordDetailExample | null = null;
  @Input() showLongVowels = true;

  private popupRef: ComponentRef<LinkExamplePopupComponent> | null = null;

  constructor(
    private dynamicSvc: DynamicComponentService,
    private globalEventSvc: GlobalEventService,
  ) {
  }

  ngOnDestroy(): void {
    this.closePopup();
  }

  openExample(event: MouseEvent): void {
    event.preventDefault();
    event.stopPropagation();

    if (this.popupRef) {
      this.closePopup();
      return;
    }

    this.globalEventSvc.Click(event, true);

    if (!this.example) {
      throw new Error('LinkExampleComponent.openExample: example is null');
    }

    this.popupRef = this.dynamicSvc.createComponent(LinkExamplePopupComponent, this.container);
    this.popupRef.instance.example = this.example;
    this.popupRef.instance.close.subscribe(() => this.closePopup());
    this.popupRef.instance.viewInit.subscribe((nativeEl: HTMLElement) => {
      timer(LINK_POPUP_DELAY).subscribe(() => {
        scrollIntoView(nativeEl, {
          behavior: 'smooth',
          block: 'end',
          scrollMode: 'if-needed',
        });
      });
    });
    this.popupRef.changeDetectorRef.detectChanges();
  }

  private closePopup(): void {
    if (this.popupRef) {
      this.popupRef.destroy();
      this.popupRef = null;
    }
  }
}
